module.exports = __webpack_public_path__ + "static/media/bird-budgie1.040f48e3.aac";